import React from 'react';

const ErrorPage = () => {
    return ( <>
        <h1 className="h3 mb-5 fw-normal">Test ErrorPage</h1>
    </> );
}
 
export default ErrorPage;